import { useTheme } from "../context/ThemeContext";

type TextFieldProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  onSubmit?: () => void;
  placeholder?: string;
  style?: React.CSSProperties;
  UpperCase?: boolean; // <- NOVO
};

// cor base vindo do theme (com fallback)

const CodeReaderField: React.FC<TextFieldProps> = ({
  label,
  value,
  onChange,
  onSubmit,
  placeholder,
  style = {},
  UpperCase = false, // <- default
}) => {
  const width = style.width ?? "100%";

  const handleChange = (raw: string) => {
    const v = UpperCase ? raw.toUpperCase() : raw;
    onChange(v);
  };
  const { theme } = useTheme();
  const primaryColor = theme?.primary;
  return (
    <div style={{ marginTop: "25px", marginLeft: style.marginLeft ?? 0 }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        {/* Esquerda: QR Code */}
        <div
          style={{
            width: "100px",
            height: "43px",
            backgroundColor: "#D9D9D9",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            border: "1px solid #8A8A8A",
            borderRight: "none",
          }}
        >
          QR Code
        </div>

        {/* Campo de entrada */}
        <input
          type="text"
          value={UpperCase ? (value ?? "").toUpperCase() : value}
          onChange={(e) => handleChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && onSubmit) onSubmit();
          }}
          placeholder={placeholder}
          style={{
            width: width,
            height: "45px",
            borderTop: "1px solid #8A8A8A",
            borderBottom: "1px solid #8A8A8A",
            borderLeft: "none",
            borderRight: "none",
            padding: "0 8px",
            fontSize: "14px",
            outline: "none",
            boxSizing: "border-box",
            textTransform: UpperCase ? "uppercase" : "none", // visual
          }}
        />

        {/* Direita: botão Enviar */}
        <div
          onClick={onSubmit}
          style={{
            width: "100px",
            height: "43px",
            backgroundColor: primaryColor,
            color: "#fff",
            fontSize: "14px",
            fontFamily: "Inter, sans-serif",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            border: "1px solid #124280",
            borderLeft: "none",
          }}
        >
          Enviar
        </div>
      </div>
    </div>
  );
};

export default CodeReaderField;
